import React, { Component } from 'react'

import CloseIcon from '@material-ui/icons/Close'
import green from '@material-ui/core/colors/green'
import red from '@material-ui/core/colors/red'
import amber from '@material-ui/core/colors/amber'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import { withStyles } from '@material-ui/core/styles'

const styles = () => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: red[700]
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
})

class CustomizedSnackbars extends Component {
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.props.close()
  }

  render() {
    const { classes, message, status, close, opened, autoHide } = this.props

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={opened}
        autoHideDuration={autoHide || 4000}
        onClose={this.handleClose}
      >
        <SnackbarContent
          className={classes[status]}
          message={<span className={classes.message}>{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={close}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>
          ]}
        />
      </Snackbar>
    )
  }
}
export default withStyles(styles)(CustomizedSnackbars)



// WEBPACK FOOTER //
// ./src/components/Snackbar.js